import { keyBy } from 'lodash';
import { ManagedLabels, ProjectLabel } from '../types';

export const getManagedLabels = (values: ProjectLabel[], initialLabels: ProjectLabel[]) => {
  const initialLabelsToManage: ManagedLabels = {
    newLabels: [],
    updatedLabels: [],
    deletedLabels: [],
  };
  /** reference for existing labels */
  const mapper = keyBy(initialLabels, 'id');
  /** All initial IDs that will be filtered down to find lables to be deleted */
  const labelIds = Object.keys(mapper).map((id) => ({ id: Number(id) }));

  const updated = values.reduce(
    (acc, label) => {
      // new labels should have a negative id
      const isNewLabel = label.id < 0;
      if (isNewLabel) {
        acc.newLabels.push({ name: label.name });
      }

      // edited labels are found in the mapper but have a different name (with positive id)
      const isEditedLabel = mapper[label.id]?.name !== label.name && label.id >= 0;
      if (isEditedLabel) {
        acc.updatedLabels.push({ id: label.id, name: label.name });
      }

      // deleted labels are those that are not found in the current values
      const filtered = acc.deletedLabels.filter((l) => l.id !== label.id);

      return { ...acc, deletedLabels: filtered };
    },
    {
      ...initialLabelsToManage,
      deletedLabels: labelIds,
    },
  );
  return updated;
};
